/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

/**
 * Supporting text, in sentence case, at the size the rest of the site reads at.
 *
 * Feather's `caption` and `caption_highlight` both set `text-transform:
 * uppercase`, which is right for a short signpost — "YOU ARE HERE", "ARRIVED
 * FROM" — and wrong for anything with a sentence in it. This section is mostly
 * sentences: what a percentage is a share of, the footnote explaining what is
 * being counted, the question at the bottom. Set in capitals they all read as
 * shouting.
 *
 * `body_normal` is the same family and weight without the transform, so it is used
 * as it comes — 1.6rem, the same size as the section's body copy, and its own line
 * height with it. These were a caption-sized 1rem, which is too small to read
 * comfortably for anything with a sentence in it; that they now match the intro
 * paragraph is fine, because what separates them from it is colour.
 */
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const quietText = css`
    ${theme.typography.body_normal}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

/**
 * The small version, for the one place with no room to grow.
 *
 * A card in a hand shares the height of the tallest card beside it, and how many
 * lines its tagline wraps to changes with the width of the page, so the copy on a
 * card stays at the caption size the whole section used to be set in — hence
 * `body_small` pulled back rather than `quietText` shrunk, which would take
 * `body_normal`'s line height down with it.
 */
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const quietTextSmall = css`
    ${theme.typography.body_small}
    font-size: var(--typography-font-size-xs);
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

/**
 * The same, for text that needs to carry weight — the name on a card.
 *
 * No size override here: `caption_highlight` is already a step larger than
 * `caption`, and `body_small_highlight` is that same larger size, so the two line
 * up on their own.
 */
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const quietTextHighlight = css`
    ${theme.typography.body_small_highlight}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
